import React, {Component} from 'react';
import { connect } from 'react-redux';
import StarRatingComponent from 'react-star-rating-component';
import {withRouter} from 'react-router';

class CinemapRating extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rating: this.props.rating
        };
    }

    componentWillReceiveProps(nextProps){
        if (this.props.rating !== nextProps.rating){
            this.setState({rating: nextProps.rating});
        }
    }

    render() {
        return (
            <div className="cinemap-rating">
                <StarRatingComponent
                    name="rate1"
                    editing={false}
                    starCount={5}
                    value={this.state.rating}
                    starColor={'#ffffff'}
                    emptyStarColor={'#4B6272'}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {})(CinemapRating));





// WEBPACK FOOTER //
// ./src/SHARED/components/cinemaprating/cinemaprating.component.js